import api from './api';

export async function fetchProjects() {
  const res = await api.get('/projects');
  return res.data || [];
}

export async function fetchProjectDetail(projectId) {
  const res = await api.get(`/projects/${projectId}`);
  return res.data;
}

export async function createProject(body) {
  const res = await api.post('/projects', body);
  return res.data;
}

export async function createProperty(body) {
  const res = await api.post('/properties', body);
  return res.data;
}

export async function createUnit(body) {
  const res = await api.post('/units', body);
  return res.data;
}

export async function createUnitsBulk(units, { property_id, project_id } = {}) {
  const res = await api.post('/units/bulk', { units, property_id, project_id });
  return res.data;
}

export async function createListing(body) {
  const res = await api.post('/listings', body);
  return res.data;
}
